import React from 'react';
import './MessagePippip.css';

export default function MessagePippip({ message, name = 'Pippip', time }) {
    // Highlight links in message
    const renderMessage = (msg) => {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const parts = String(msg).split(urlRegex);
        return parts.map((part, idx) => {
            if (urlRegex.test(part)) {
                return <a key={idx} href={part} className="message-link-highlight" target="_blank" rel="noopener noreferrer">{part}</a>;
            }
            return part;
        });
    };
    return (
        <div className="message-pippip-container">
            <div className="message-pippip-row-grid">
                {/* Row 1: meta */}
                <div className="message-pippip-empty" />
                <div className="message-pippip-meta">
                    <span className="message-pippip-name">{name}</span>
                    {time && <span className="message-pippip-time">{time}</span>}
                </div>
                {/* Row 2: avatar + message */}
                <div className="message-pippip-avatar">
                    <img
                        src="../../../Image/logo-pippip.png"
                        alt="Pippip Logo"
                        className="message-pippip-logo"
                    />
                </div>
                <div className="message-pippip-bubble">
                    {renderMessage(message)}
                </div>
            </div>
        </div>
    );
}
